var _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _rect, _rect2, _path3, _polygon9, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _circle3, _rect3, _rect4, _rect5, _rect6, _rect7, _path12, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _circle4, _circle5, _path13, _polygon10, _polygon11, _path14, _polygon12, _rect15, _rect16, _path15, _polygon13, _polygon14, _circle6, _circle7, _rect17, _rect18, _path16, _path17, _path18, _path19, _path20, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _rect19, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _path21, _path22, _path23, _g22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a9745a72-b278-468b-8658-92c282aa8c47",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 865,
    height: 628,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.53,664.61S32,583.43,43.8,498.19,152.24,484,175.9,406.86,112.35,229,191.45,158.6,343.5,155.2,392.8,141,438.15,17.19,550.54,15.16,756.1,82.13,714.44,280,801,500.22,818.69,571.25s-26,95.81-26,95.81Z",
    fill: "#5f8dfa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.53,664.61S32,583.43,43.8,498.19,152.24,484,175.9,406.86,112.35,229,191.45,158.6,343.5,155.2,392.8,141,438.15,17.19,550.54,15.16,756.1,82.13,714.44,280,801,500.22,818.69,571.25s-26,95.81-26,95.81Z",
    fill: "#fff",
    opacity: 0.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "262.54 619.33 257.84 667.78 267.62 667.78 278.97 619.33 262.54 619.33",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "278.97 667.78 283.66 619.33 301.27 619.33 290.12 667.78 278.97 667.78",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "658.06 619.33 662.75 667.78 652.97 667.78 641.63 619.33 658.06 619.33",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "641.63 667.78 636.93 619.33 619.33 619.33 630.48 667.78 641.63 667.78",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "376.71 495.18 373.62 474.45 386.93 474.45 383.86 495.18 376.71 495.18",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "395.61 474.45 399.19 495.18 406.34 495.18 411.45 474.45 395.61 474.45",
    fill: "#2f2e41"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "563.92 495.18 560.84 474.45 574.14 474.45 571.08 495.18 563.92 495.18",
    fill: "#2f2e41"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "582.83 474.45 586.4 495.18 593.56 495.18 598.66 474.45 582.83 474.45",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 348.63,
    width: 217.95,
    height: 129.85,
    fill: "#5f8dfa"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 348.63,
    width: 217.95,
    height: 129.85,
    fill: "#fff",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M554.7,466.59H413.82a6.49,6.49,0,0,1-6.32-5,210.2,210.2,0,0,1,0-94.7,6.48,6.48,0,0,1,6.32-5H554.7a10.62,10.62,0,0,1,10.56,9.42,391.73,391.73,0,0,1,0,85.91A10.63,10.63,0,0,1,554.7,466.59Z",
    fill: "#5f8dfa",
    opacity: 0.24
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.94 57.63 648.86 47.24 656.85 288.46 370.76 297.55 364.06 251.15 357.36 276.51 350.67 260.24 344.45 277.7 328.19 204.28 311.44 253.55 302.94 57.63",
    fill: "#5f8dfa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M352,203.17l38-76.85h16.36l-37.09,76h55.56v13.79H352ZM400.83,170h15.51v62.47H400.83Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M452.54,225.51q-8.24-8-8.23-22.19V155.08q0-14.31,8.26-22.22t24.08-7.92q15.9,0,24.12,7.88T509,155.08v48.24q0,14.31-8.26,22.22t-24.08,7.92Q460.77,233.46,452.54,225.51Zm36.54-10.33q4-4.12,4-11.86V155.08q0-7.74-4-11.86t-12.47-4.12q-8.49,0-12.46,4.12t-4,11.86v48.24q0,7.74,4,11.86t12.42,4.12Q485.08,219.3,489.08,215.18Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M530.81,203.17l38-76.85h16.37l-37.09,76h55.56v13.79H530.81ZM579.68,170h15.51v62.47H579.68Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M439.37,81.93l3.4-.15,1.1,24.94-3.39.15Zm1.65-.07,13.9-.61.14,3.32-13.89.62Zm.48,10.89,12.07-.53.15,3.32-12.07.54Zm.48,10.72,13.9-.61.14,3.32-13.89.62Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M459.73,88.18l3.39-.15.79,17.8-3.39.15Zm8.52,3a4.06,4.06,0,0,0-1.6-.22,3.34,3.34,0,0,0-2.46,1,3.48,3.48,0,0,0-.78,2.58l-.5-3.41a6.6,6.6,0,0,1,1.95-2.57,4.81,4.81,0,0,1,2.76-1,6.23,6.23,0,0,1,2.16.26,4.73,4.73,0,0,1,1.71,1L469.42,92A2.81,2.81,0,0,0,468.25,91.17Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M474.27,87.53l3.4-.15.79,17.81-3.4.15Zm8.52,3a4,4,0,0,0-1.59-.23,3.31,3.31,0,0,0-2.46,1,3.49,3.49,0,0,0-.78,2.59l-.5-3.42a6.48,6.48,0,0,1,2-2.57,4.77,4.77,0,0,1,2.76-1,6.2,6.2,0,0,1,2.15.25,4.79,4.79,0,0,1,1.72,1L484,91.33A2.76,2.76,0,0,0,482.79,90.53Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M492,103.93a5.9,5.9,0,0,1-2.55-2.54,9.69,9.69,0,0,1-1-4.16l-.13-2.9a9.35,9.35,0,0,1,.66-4.17,5.89,5.89,0,0,1,2.32-2.74,8.67,8.67,0,0,1,7.69-.34,5.93,5.93,0,0,1,2.56,2.52,9.35,9.35,0,0,1,1,4.1l.13,3a9.43,9.43,0,0,1-.66,4.2,5.88,5.88,0,0,1-2.32,2.74,8.58,8.58,0,0,1-7.69.34Zm6.44-3.86a4.8,4.8,0,0,0,.84-3.26l-.14-3a4.79,4.79,0,0,0-1.11-3.16,3.93,3.93,0,0,0-5.51.24,4.83,4.83,0,0,0-.83,3.25l.13,3a4.81,4.81,0,0,0,1.12,3.18,3.88,3.88,0,0,0,5.5-.25Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M507.06,86.08l3.39-.15.79,17.8-3.39.15Zm8.52,3a4.06,4.06,0,0,0-1.6-.22,3.34,3.34,0,0,0-2.46,1,3.52,3.52,0,0,0-.78,2.58l-.5-3.41a6.6,6.6,0,0,1,2-2.57,4.81,4.81,0,0,1,2.76-1,6.23,6.23,0,0,1,2.16.26,4.73,4.73,0,0,1,1.71,1l-2.07,3.19A2.81,2.81,0,0,0,515.58,89.07Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 323.08,
    cy: 69.71,
    r: 3.51,
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 633.68,
    cy: 62.69,
    r: 3.51,
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 640.7,
    cy: 272.8,
    r: 3.51,
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 241.34,
    y: 495.18,
    width: 434.96,
    height: 124.15,
    fill: "#5f8dfa"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 253.57,
    y: 503.04,
    width: 68.84,
    height: 108.81,
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 332.78,
    y: 503.04,
    width: 68.84,
    height: 108.81,
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 584.65,
    y: 472.87,
    width: 50.6,
    height: 110.93,
    transform: "translate(1138.28 -81.61) rotate(90)",
    fill: "#2f2e41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 584.65,
    y: 531.09,
    width: 50.6,
    height: 110.93,
    transform: "translate(1196.5 -23.39) rotate(90)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M312.31,544.55h2.2a0,0,0,0,1,0,0v18.76a0,0,0,0,1,0,0h-2.2a8.4,8.4,0,0,1-8.4-8.4v-2A8.4,8.4,0,0,1,312.31,544.55Z",
    fill: "#5f8dfa"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 414.98,
    y: 503.04,
    width: 129.34,
    height: 108.81,
    fill: "#fff",
    opacity: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 414.98,
    y: 522.16,
    width: 14.42,
    height: 89.69,
    fill: "#2f2e41"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 429.4,
    y: 537.09,
    width: 6.57,
    height: 74.76,
    fill: "#5f8dfa"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 435.97,
    y: 528.34,
    width: 7.39,
    height: 83.52,
    fill: "#d1d3d4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 454.78,
    y: 602.25,
    width: 36.35,
    height: 4.15,
    fill: "#2f2e41"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 458.82,
    y: 606.4,
    width: 49.86,
    height: 5.46,
    fill: "#d1d3d4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 570.26,
    y: 426.09,
    width: 32.13,
    height: 45.34,
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 586.33,
    cy: 405.63,
    r: 11.22,
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 586.33,
    cy: 375.78,
    r: 11.22,
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M493.23,387l1.57,14.35,8,3.35s-3.81,7.49-4.77,14l-15.16,8.13,15.46-4.3s4.95,11.64,15.95,7.49l2.07,12,.48-15.92,3.51-6.08,3.34,3.82,7.82-7.65,6.69,5.58-1.75,8.45L542,419.05l-7.65-10.36,5.1-9.89-9.25,8.61-9.88-4.78-3.67-20.73L516,402l-8.93.8-9.56-4.47Z",
    fill: "#2f2e41"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.95 393.71 489.25 373.17 489.52 373.09 495.22 393.64 494.95 393.71",
    fill: "#2f2e41"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "535.34 404.8 535.11 404.63 545.71 389.79 545.94 389.95 535.34 404.8",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M474.69,437.71h-.27v-3.95a5.09,5.09,0,0,1,3-4.66l10-4.42.12.25-10,4.42a4.83,4.83,0,0,0-2.87,4.41Z",
    fill: "#2f2e41"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "531.13 442.07 530.87 441.95 539.32 423.56 539.58 423.68 531.13 442.07",
    fill: "#2f2e41"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 355.25,
    y: 348.63,
    width: 36.75,
    height: 129.85,
    fill: "#2f2e41"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 355.25,
    y: 348.63,
    width: 36.75,
    height: 129.85,
    opacity: 0.22
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M482.84,335.11h11.24a12.11,12.11,0,0,1,12.11,12.11v1.41a0,0,0,0,1,0,0H470.73a0,0,0,0,1,0,0v-1.41A12.11,12.11,0,0,1,482.84,335.11Z",
    fill: "#2f2e41"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "477.15 337.07 470.32 322.85 435.31 307.51 431.91 288.56 433.01 288.37 436.31 306.73 471.14 322 478.16 336.58 477.15 337.07",
    fill: "#2f2e41"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "501.52 338.07 500.42 337.88 505.71 307.04 528.67 307.04 538.12 276.34 539.19 276.67 529.5 308.16 506.65 308.16 501.52 338.07",
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.58,
    cy: 284.76,
    r: 4.9,
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.65,
    cy: 272.8,
    r: 4.9,
    fill: "#2f2e41"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 584.55,
    y: 371.13,
    width: 11.21,
    height: 1.12,
    transform: "translate(-84.48 548.62) rotate(-46.9)",
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 403.7,
    width: 1.12,
    height: 11.22,
    transform: "translate(-105.84 586.28) rotate(-48.98)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M364.06,348.63s.73,45.51-8.16,59.56",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M372.13,349.79s6.28,32.85-2.81,55.84c0,0-4.94,20.23,4.95,43.13l12.06,29.71",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M391.32,441.2s-16.46-18.42-14.11-40.14a35.53,35.53,0,0,1,4.56-13.48c2.63-4.67,7.6-16.79,5.16-38.95",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M356.37,435.34s22.55,18.57,20.62,43.13",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M356.37,455.41s8.44,6.35,14.39,23.06",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.36 436.2 570.16 436.02 579.37 426 579.57 426.19 570.36 436.2",
    fill: "#fff"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.36 447.69 570.16 447.49 591.72 426 591.91 426.19 570.36 447.69",
    fill: "#fff"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.36 459.52 570.16 459.33 602.29 426 602.49 426.19 570.36 459.52",
    fill: "#fff"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.36 471.52 570.16 471.33 602.29 437.61 602.5 437.8 570.36 471.52",
    fill: "#fff"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "581.14 471.52 580.94 471.33 602.29 448.67 602.5 448.86 581.14 471.52",
    fill: "#fff"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "591.92 471.52 591.71 471.33 602.29 460 602.5 460.19 591.92 471.52",
    fill: "#fff"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "590.06 471.53 570.16 451.81 570.36 451.61 590.26 471.33 590.06 471.53",
    fill: "#fff"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "602.3 471.53 570.16 440.23 570.36 440.03 602.49 471.33 602.3 471.53",
    fill: "#fff"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "602.3 459.53 570.17 430.31 570.36 430.11 602.49 459.32 602.3 459.53",
    fill: "#fff"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "602.3 447.69 579.37 426.19 579.56 425.99 602.49 447.49 602.3 447.69",
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 596.96,
    y: 423.82,
    width: 0.28,
    height: 14.57,
    transform: "translate(-126.47 568.29) rotate(-46.56)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.77,532l-.58-1c.28-.17,28.24-17.1,38.91-28.35l.81.76C583.14,514.79,555.05,531.8,554.77,532Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.81,547.53l-.66-.9c.16-.11,16.3-12,24.63-19.4.85-.76,1.56-1.35,2.24-1.87,5.33-4,23.3-17.63,30.66-22.78l.64.92c-7.35,5.13-25.3,18.71-30.62,22.75-.66.5-1.35,1.07-2.18,1.81C571.15,535.54,555,547.42,554.81,547.53Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.16,554.1l-.64-.92c.19-.13,19.4-13.36,36.41-19.06.39-.17,43.41-18.31,49-31.3l1,.44c-5.76,13.41-47.84,31.15-49.63,31.9C580.43,540.82,561.35,554,561.16,554.1Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.17,554.15l-.45-1c.33-.14,32.8-14.5,55.25-43.38l.88.68C643.23,539.55,610.5,554,610.17,554.15Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.02,
    y: 543.11,
    width: 31.02,
    height: 1.12,
    transform: "translate(-196.56 547.37) rotate(-40.01)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.81,584.14l-.66-.9c.15-.1,15-11.1,25.66-22.37l.81.77C569.86,573,555,584,554.81,584.14Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.87,604.41l-.79-.78c.1-.1,9.44-9.49,17.8-17,.85-.75,1.56-1.35,2.25-1.87,2-1.52,5-5.29,8.12-9.29,4.32-5.49,9.21-11.7,13.52-14.71l.64.91c-4.18,2.92-9,9.07-13.28,14.49-3.33,4.23-6.21,7.89-8.33,9.49-.66.5-1.35,1.08-2.18,1.82C564.29,595,555,604.32,554.87,604.41Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.75,612.34l-.54-1a227.81,227.81,0,0,1,31.94-13.78c.32-.13,34.16-13.34,49-36.62l1,.59c-15,23.6-49.2,37-49.54,37.08A224.94,224.94,0,0,0,554.75,612.34Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.28,612.38l-.35-1.06c.44-.14,44.61-15.06,68-50.37l.93.61C642.26,597.21,597.73,612.24,597.28,612.38Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M638.05,612.27l-.74-.83a149.5,149.5,0,0,0,27.63-32.81l.95.59A150.42,150.42,0,0,1,638.05,612.27Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254,542.39l-.84-.74a95.24,95.24,0,0,0,20-38.72l1.09.22A96.43,96.43,0,0,1,254,542.39Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.9,574.93l-.65-.91c6.66-4.73,16.21-17.54,19-21.35.74-1,1.51-2,2.28-3l.23-.3c18.33-23.62,18.81-46.11,18.81-46.34l1.12,0c0,.22-.47,23.07-19.05,47l-.23.29c-.76,1-1.53,2-2.26,3C269.55,558.26,260.5,570.23,253.9,574.93Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254,604.32l-.93-.6a143.7,143.7,0,0,1,9.49-11.54,80.13,80.13,0,0,1,8.87-8.72c33.51-27.8,31.9-79.88,31.88-80.4l1.11,0c0,.53,1.66,53.14-32.28,81.3a80.58,80.58,0,0,0-8.75,8.6A135.24,135.24,0,0,0,254,604.32Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.28,612l-1.06-.33c.06-.23,1.85-5.8,17.27-21.64,1.91-1.95,4-3.92,6.15-5.87,5.21-4.65,17.61-16.59,20.24-26.87l1.08.28c-2.7,10.57-15.29,22.7-20.58,27.42-2.15,1.93-4.2,3.89-6.09,5.82C281.17,606.36,279.3,612,279.28,612Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.29,612.26l-.77-.81c.15-.15,15.47-15.12,18.35-28.93l1.09.23C320,596.89,304.93,611.63,304.29,612.26Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.19,528.72l-.82-.76c10.2-10.9,18.48-25.06,18.56-25.2l1,.56C351.81,503.46,343.47,517.72,333.19,528.72Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "333.24 557.57 332.32 556.94 340.96 544.23 373.18 502.7 374.06 503.38 341.87 544.89 333.24 557.57"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.24,586.88l-.92-.65c4.77-6.77,16.65-22,23.3-30.45,1.94-2.46,4-4.77,6.44-7.47,15.28-16.78,23.65-45.14,23.74-45.43l1.07.32c-.09.28-8.53,28.89-24,45.86-2.45,2.69-4.47,5-6.39,7.41C351.15,563.28,338.17,579.87,333.24,586.88Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.36,612l-1.08-.29c.07-.26,7.22-25.64,25.61-37.88a84.64,84.64,0,0,0,9.5-7.16c9.51-8.49,25.75-25.87,27.67-46.84l1.12.1c-2,21.35-18.41,39-28,47.58a86.23,86.23,0,0,1-9.64,7.25C346.47,586.76,339.43,611.75,339.36,612Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359,612.08c-.16-.38-3.9-9.46,7.7-25.85.18-.24,17.44-24.05,19.64-33.22l1.09.26c-2.25,9.39-19.1,32.63-19.82,33.61-11.2,15.81-7.62,24.67-7.58,24.75Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.72,
    y: 587.02,
    width: 56.28,
    height: 1.12,
    transform: "translate(-315.2 624.81) rotate(-59.6)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M348.61,544.55h2.2a0,0,0,0,1,0,0v18.76a0,0,0,0,1,0,0h-2.2a8.4,8.4,0,0,1-8.4-8.4v-2A8.4,8.4,0,0,1,348.61,544.55Z",
    transform: "translate(691.01 1107.85) rotate(180)",
    fill: "#5f8dfa"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M613,507.48h2.2a0,0,0,0,1,0,0v18.76a0,0,0,0,1,0,0H613a8.4,8.4,0,0,1-8.4-8.4v-2a8.4,8.4,0,0,1,8.4-8.4Z",
    transform: "translate(93.09 1126.8) rotate(-90)",
    fill: "#5f8dfa"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M613,564.24h2.2a0,0,0,0,1,0,0V583a0,0,0,0,1,0,0H613a8.4,8.4,0,0,1-8.4-8.4v-2A8.4,8.4,0,0,1,613,564.24Z",
    transform: "translate(36.32 1183.57) rotate(-90)",
    fill: "#5f8dfa"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "ff052c1b-c41f-4806-8f0b-b0d2ba46f647",
    "data-name": "freepik--Plant--inject-88"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "254.84 495.14 247.85 451.23 301.44 451.89 296.16 494.57",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,443.21a9.11,9.11,0,0,0,8.93.75,9.65,9.65,0,0,0,4.87-7.69,11,11,0,0,0-8.93-.44,10.77,10.77,0,0,0-5.91,6.6",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.47,452.67a9.14,9.14,0,0,0,8.93.75,9.64,9.64,0,0,0,4.87-7.69,10.92,10.92,0,0,0-8.93-.45,10.8,10.8,0,0,0-5.92,6.61",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.72,431.55a9.14,9.14,0,0,0,7,5.53,9.68,9.68,0,0,0,8.3-3.75,10.29,10.29,0,0,0-13.94-4.21,10.41,10.41,0,0,0-1.79,1.21",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.66,442.49a9.15,9.15,0,0,0-8,4,9.62,9.62,0,0,0-.18,9.1,10.28,10.28,0,0,0,9.8-10.74,10,10,0,0,0-.34-2.18",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.3,459.78a9.13,9.13,0,0,0,.21,8.93,9.59,9.59,0,0,0,8.17,4,10.9,10.9,0,0,0-.51-8.87c-1.41-2.57-3.94-3.83-7.12-4.55",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.54,461.81a6.23,6.23,0,0,0-2.12-1.35,9.22,9.22,0,0,0-2.9-.52,37.25,37.25,0,0,0-4,.24,11.46,11.46,0,0,1-4.87-.43,7.41,7.41,0,0,1-4-3.88,21.84,21.84,0,0,1-1.73-5.93,17.32,17.32,0,0,0-2.06-6.08,21.85,21.85,0,0,0-4.55-4.61,21.76,21.76,0,0,1-4.33-4.4,14.6,14.6,0,0,1-2.16-10,14.13,14.13,0,0,1,2.63-6.49,10.79,10.79,0,0,1,1.29-1.41,2.69,2.69,0,0,1,.51-.44,2.64,2.64,0,0,1-.43.52,14.06,14.06,0,0,0-1.18,1.47,14.71,14.71,0,0,0-.22,16.14,22,22,0,0,0,4.26,4.26,21.77,21.77,0,0,1,4.66,4.73,17.33,17.33,0,0,1,2.14,6.29,21.75,21.75,0,0,0,1.66,5.8,7,7,0,0,0,3.71,3.67,11.2,11.2,0,0,0,4.67.46,33.42,33.42,0,0,1,4-.14,8.72,8.72,0,0,1,3,.62,5,5,0,0,1,1.61,1,2.43,2.43,0,0,1,.33.38C320.52,461.75,320.55,461.8,320.54,461.81Z",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.54,461.81a6.23,6.23,0,0,0-2.12-1.35,9.22,9.22,0,0,0-2.9-.52,37.25,37.25,0,0,0-4,.24,11.46,11.46,0,0,1-4.87-.43,7.41,7.41,0,0,1-4-3.88,21.84,21.84,0,0,1-1.73-5.93,17.32,17.32,0,0,0-2.06-6.08,21.85,21.85,0,0,0-4.55-4.61,21.76,21.76,0,0,1-4.33-4.4,14.6,14.6,0,0,1-2.16-10,14.13,14.13,0,0,1,2.63-6.49,10.79,10.79,0,0,1,1.29-1.41,2.69,2.69,0,0,1,.51-.44,2.64,2.64,0,0,1-.43.52,14.06,14.06,0,0,0-1.18,1.47,14.71,14.71,0,0,0-.22,16.14,22,22,0,0,0,4.26,4.26,21.77,21.77,0,0,1,4.66,4.73,17.33,17.33,0,0,1,2.14,6.29,21.75,21.75,0,0,0,1.66,5.8,7,7,0,0,0,3.71,3.67,11.2,11.2,0,0,0,4.67.46,33.42,33.42,0,0,1,4-.14,8.72,8.72,0,0,1,3,.62,5,5,0,0,1,1.61,1,2.43,2.43,0,0,1,.33.38C320.52,461.75,320.55,461.8,320.54,461.81Z",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.21,466.31a13.56,13.56,0,0,0-18.34-13.4,22.62,22.62,0,0,0,17.85,13.2",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.68,468.17c-2.63,2.88-2.46,7.51-.58,10.93s5.1,5.83,8.33,8a17.6,17.6,0,0,0-7.57-20",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.38,454.68a15.63,15.63,0,0,0,17.08,14l.66-.08c-1-4.22-2.7-8.46-6-11.32s-8.39-3.93-12-1.52",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.27,450.38c-.66-3.84-4.47-6.62-8.32-7s-7.7,1.3-10.8,3.64a14.07,14.07,0,0,0,19.16,1.9",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.32,483c-3.68,3.14-4.6,8.74-3.07,13.33s5.11,8.25,9.13,10.94c1.55-4.56,2.52-9.43,1.71-14.18s-3.67-9.31-8.07-11.24",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.7,439.62a11.3,11.3,0,0,1,15.71-3,12.2,12.2,0,0,1,2.15,1.91,9.77,9.77,0,0,1-17.64.45",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.21,428.56a14.71,14.71,0,0,1-18.35-9.81,13.84,13.84,0,0,1-.4-1.69,33.2,33.2,0,0,1,8.85.13,14.41,14.41,0,0,1,7.81,3.86,7.82,7.82,0,0,1,2,7.51",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.71,425.69A12,12,0,0,1,238,408.76a12.25,12.25,0,0,1,1.6-1.62,25.2,25.2,0,0,1,5.26,11.22,9.31,9.31,0,0,1,0,4.63,4.27,4.27,0,0,1-3.24,3",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.21,466.31a13.56,13.56,0,0,0-18.34-13.4,22.62,22.62,0,0,0,17.85,13.2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.68,468.17c-2.63,2.88-2.46,7.51-.58,10.93s5.1,5.83,8.33,8a17.6,17.6,0,0,0-7.57-20"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.38,454.68a15.63,15.63,0,0,0,17.08,14l.66-.08c-1-4.22-2.7-8.46-6-11.32s-8.39-3.93-12-1.52"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.27,450.38c-.66-3.84-4.47-6.62-8.32-7s-7.7,1.3-10.8,3.64a14.07,14.07,0,0,0,19.16,1.9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.32,483c-3.68,3.14-4.6,8.74-3.07,13.33s5.11,8.25,9.13,10.94c1.55-4.56,2.52-9.43,1.71-14.18s-3.67-9.31-8.07-11.24"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.7,439.62a11.3,11.3,0,0,1,15.71-3,12.2,12.2,0,0,1,2.15,1.91,9.77,9.77,0,0,1-17.64.45"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.21,428.56a14.71,14.71,0,0,1-18.35-9.81,13.84,13.84,0,0,1-.4-1.69,33.2,33.2,0,0,1,8.85.13,14.41,14.41,0,0,1,7.81,3.86,7.82,7.82,0,0,1,2,7.51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.71,425.69A12,12,0,0,1,238,408.76a12.25,12.25,0,0,1,1.6-1.62,25.2,25.2,0,0,1,5.26,11.22,9.31,9.31,0,0,1,0,4.63,4.27,4.27,0,0,1-3.24,3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.41,452.65a1.61,1.61,0,0,1,0-.31,5,5,0,0,1,.06-.88c0-.78.12-1.92.14-3.35a30.28,30.28,0,0,0-2-12.17,18.52,18.52,0,0,0-4.89-6.9,13.11,13.11,0,0,0-8.93-3.28,11.18,11.18,0,0,0-5,1.26,9.93,9.93,0,0,0-3.88,3.7c-1.94,3.22-2.43,7.24-2.23,11.17s.7,7.94.27,11.78a18.43,18.43,0,0,1-1.48,5.46,11.43,11.43,0,0,1-3.35,4.32,16.62,16.62,0,0,1-4.59,2.35,23.89,23.89,0,0,0-4.34,2,15.75,15.75,0,0,0-5.68,6.19,15.07,15.07,0,0,0-1.64,6.78,16.29,16.29,0,0,0,.86,5.23,19.42,19.42,0,0,0,2,4.08s-.07-.07-.2-.23-.35-.47-.51-.72a13.83,13.83,0,0,1-1.53-3.05,15.54,15.54,0,0,1-1-5.31,15.17,15.17,0,0,1,1.6-7,16.12,16.12,0,0,1,5.79-6.41c2.65-1.77,6.15-2.24,8.85-4.32s4.12-5.75,4.53-9.44-.13-7.65-.28-11.69.3-8.17,2.34-11.52a10.54,10.54,0,0,1,4.12-3.91,11.66,11.66,0,0,1,5.27-1.3,13.53,13.53,0,0,1,9.24,3.45,19.06,19.06,0,0,1,5,7.09,25.65,25.65,0,0,1,1.68,7,37.3,37.3,0,0,1,.15,5.39,26.49,26.49,0,0,1-.26,3.4,4.43,4.43,0,0,1-.11.87A1.08,1.08,0,0,1,254.41,452.65Z",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.41,452.65a1.61,1.61,0,0,1,0-.31,5,5,0,0,1,.06-.88c0-.78.12-1.92.14-3.35a30.28,30.28,0,0,0-2-12.17,18.52,18.52,0,0,0-4.89-6.9,13.11,13.11,0,0,0-8.93-3.28,11.18,11.18,0,0,0-5,1.26,9.93,9.93,0,0,0-3.88,3.7c-1.94,3.22-2.43,7.24-2.23,11.17s.7,7.94.27,11.78a18.43,18.43,0,0,1-1.48,5.46,11.43,11.43,0,0,1-3.35,4.32,16.62,16.62,0,0,1-4.59,2.35,23.89,23.89,0,0,0-4.34,2,15.75,15.75,0,0,0-5.68,6.19,15.07,15.07,0,0,0-1.64,6.78,16.29,16.29,0,0,0,.86,5.23,19.42,19.42,0,0,0,2,4.08s-.07-.07-.2-.23-.35-.47-.51-.72a13.83,13.83,0,0,1-1.53-3.05,15.54,15.54,0,0,1-1-5.31,15.17,15.17,0,0,1,1.6-7,16.12,16.12,0,0,1,5.79-6.41c2.65-1.77,6.15-2.24,8.85-4.32s4.12-5.75,4.53-9.44-.13-7.65-.28-11.69.3-8.17,2.34-11.52a10.54,10.54,0,0,1,4.12-3.91,11.66,11.66,0,0,1,5.27-1.3,13.53,13.53,0,0,1,9.24,3.45,19.06,19.06,0,0,1,5,7.09,25.65,25.65,0,0,1,1.68,7,37.3,37.3,0,0,1,.15,5.39,26.49,26.49,0,0,1-.26,3.4,4.43,4.43,0,0,1-.11.87A1.08,1.08,0,0,1,254.41,452.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.46,443.07a11.25,11.25,0,0,0,.8-3.93,9.53,9.53,0,0,0-1.05-4.54,9.43,9.43,0,0,0-4.36-4.22,9.83,9.83,0,0,0-3.45-.93,11.39,11.39,0,0,0-3.85.45c-2.62.69-5.22,2.23-8.34,2.8a9.83,9.83,0,0,1-4.82-.11,7.36,7.36,0,0,1-3.94-3.15c-1.87-2.9-2.4-6.55-4.66-9.22a9.19,9.19,0,0,0-4.23-2.77,12,12,0,0,0-4.95-.5,12.61,12.61,0,0,0-8.22,4.28,19.06,19.06,0,0,0-4.09,7.55,22.59,22.59,0,0,0-.91,7.49,80.54,80.54,0,0,0,1.39,11l.5,3a3.5,3.5,0,0,0,.13.77v.27a.75.75,0,0,0-.08-.26l-.18-.76c-.14-.72-.36-1.71-.61-2.94a72.77,72.77,0,0,1-1.59-11,23.15,23.15,0,0,1,.86-7.63,19.55,19.55,0,0,1,4.15-7.81,15,15,0,0,1,3.76-3,13,13,0,0,1,10-1,9.79,9.79,0,0,1,4.47,2.95c2.39,2.87,2.9,6.53,4.7,9.29A6.71,6.71,0,0,0,307.5,432a9.27,9.27,0,0,0,4.56.12c3-.57,5.58-2,8.31-2.73a11.57,11.57,0,0,1,4-.44,10,10,0,0,1,3.59,1,9.67,9.67,0,0,1,5.46,9.13,9.22,9.22,0,0,1-.58,3A4.63,4.63,0,0,1,332.46,443.07Z",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.11,423.61a10.43,10.43,0,0,0,9.56.63,9.66,9.66,0,0,0,4.87-7.69,11,11,0,0,0-8.93-.46,10.82,10.82,0,0,0-5.9,6.61",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.28,432.83a10.38,10.38,0,0,0,4.46,8.49,9.64,9.64,0,0,0,9.11.15,11,11,0,0,0-4.24-7.81,10.87,10.87,0,0,0-8.72-1.6",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.9,430.79a10.43,10.43,0,0,0,9.58-.4,9.63,9.63,0,0,0,4-8.16,10.28,10.28,0,0,0-14.05,7.69",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,417.51c-2.57-2.23-4.3-6.11-3.81-9a9.65,9.65,0,0,1,5.92-6.93,11,11,0,0,1,3.06,8.35,10.84,10.84,0,0,1-4.57,7.6",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48,404.89a.64.64,0,0,1,.1-.24l.36-.66a27.64,27.64,0,0,1,1.55-2.42,26.09,26.09,0,0,1,7.66-7.25,19.16,19.16,0,0,1,6.89-2.53,16.88,16.88,0,0,1,8.36.89,13.62,13.62,0,0,1,7.16,5.84c1.64,2.87,2.16,6.24,3.12,9.47a17,17,0,0,0,2,4.46,13.7,13.7,0,0,0,3.4,3.35c1.27.94,2.61,1.8,3.83,2.78a16.75,16.75,0,0,1,3.11,3.35,20.79,20.79,0,0,1,3.19,7.81,27.25,27.25,0,0,1,.42,7.32,55.69,55.69,0,0,1-1.86,10.41c-.33,1.2-.6,2.14-.77,2.76a5.89,5.89,0,0,1-.32.95,6.55,6.55,0,0,1,.2-1c.16-.68.38-1.62.66-2.79A60.72,60.72,0,0,0,268.23,437a27.54,27.54,0,0,0-.49-7.19,20.42,20.42,0,0,0-3.16-7.58,15.73,15.73,0,0,0-3-3.24c-1.18-1-2.52-1.8-3.81-2.76a14.32,14.32,0,0,1-3.55-3.48,17.76,17.76,0,0,1-2.07-4.67c-1-3.28-1.5-6.59-3.08-9.34a13.08,13.08,0,0,0-6.84-5.65,16.79,16.79,0,0,0-8.1-.89,18.27,18.27,0,0,0-6.7,2.4,26.92,26.92,0,0,0-7.7,7c-.75,1-1.27,1.8-1.63,2.36A10.33,10.33,0,0,1,217.48,404.89Z",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.63,416.7c-.88-.83-1.31-.25-2.51,0a7.32,7.32,0,0,0-3.21,1.6,13.58,13.58,0,0,0-4.4,14.23,10.59,10.59,0,0,0,9.67-15.91",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.16,400.11c-.45-1.12-1.12-.79-2.23-1.12a7.43,7.43,0,0,0-3.6.07,13.57,13.57,0,0,0-10,10.95,10.59,10.59,0,0,0,15.51-10.13",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.6,439.13a12.25,12.25,0,0,0-19.19.94,15.07,15.07,0,0,0,10,3.93,15.49,15.49,0,0,0,10.05-4.06",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.61,422.38a12.37,12.37,0,0,0,12.5-14.77,11.15,11.15,0,0,0-12.91,14.64",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.82,402.68a12.39,12.39,0,0,0,16-7.07,12.16,12.16,0,0,0,.71-2.71,11.11,11.11,0,0,0-17,9.52",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.49,396.25a12.38,12.38,0,0,0-16,7.07,12,12,0,0,0-.71,2.71,11.17,11.17,0,0,0,17.1-9.5",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.38,392.78a12.35,12.35,0,0,0,6.58-18.2,11.17,11.17,0,0,0-7,18.23",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.24,393.41a12.37,12.37,0,0,0-7.4-15.86,12,12,0,0,0-2.64-.64,11.1,11.1,0,0,0,9.85,16.85",
    fill: "#5f8dfa"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.16 490.05 251.26 495.14 301.71 495.14 305.15 490.05 247.16 490.05",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.16 490.05 251.26 495.14 301.71 495.14 305.15 490.05 247.16 490.05",
    opacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.203694cbe3e50f24bdb30ab1da2bb943.svg";
export { ForwardRef as ReactComponent };